// Display labels for AccountNormalSide
import {
  AccountNormalSide,
  AccountType,
} from "types/api/deal/accounting/ledger_account";

export const accountNormalSideDisplay = {
  debit: "Debit",
  credit: "Credit",
};

// Display labels for AccountType
export const accountTypeDisplay = {
  asset: "Asset",
  liability: "Liability",
  equity: "Equity",
  revenue: "Revenue",
  expense: "Expense",
};

// Constants for dropdowns or option lists
export const ACCOUNT_NORMAL_SIDE_OPTIONS = [
  { key: "debit", label: accountNormalSideDisplay.debit },
  { key: "credit", label: accountNormalSideDisplay.credit },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { key: "asset", label: accountTypeDisplay.asset },
  { key: "liability", label: accountTypeDisplay.liability },
  { key: "equity", label: accountTypeDisplay.equity },
  { key: "revenue", label: accountTypeDisplay.revenue },
  { key: "expense", label: accountTypeDisplay.expense },
];

export const validAccountTypeMap: Record<AccountNormalSide, AccountType[]> = {
  debit: [AccountType.ASSET, AccountType.EXPENSE],
  credit: [AccountType.LIABILITY, AccountType.EQUITY, AccountType.REVENUE],
};
